import { HeroIcon } from '@components/HeroIcon'
import { MediaRender } from '@components/MediaRender'
import { Modal } from '@components/Modal'
import { ScrollBar } from '@components/ScrollBar'
import { useDynamicSnapPoints } from '@hooks/useDynamicSnapPoints'
import { useMemo } from 'react'
import { Dimensions } from 'react-native'
import { Button, useMedia, YStack } from 'tamagui'

type CourseDescriptionModalProps = {
  open: boolean
  onClose: () => void
  description: string | null
}

export function CourseDescriptionModal({
  open,
  description,
  onClose,
}: CourseDescriptionModalProps) {
  const media = useMedia()
  const { snapPoints } = useDynamicSnapPoints()

  const windowHeight = Dimensions.get('window').height

  const modalMaxWidth = useMemo(() => {
    if (media.gtMd) return 1064
    if (media.gtSm) return 672
    return 631
  }, [media.gtMd, media.gtSm])

  const maxHeight = useMemo(() => {
    if (media.gtLg) return 695
    if (media.gtMd) return windowHeight - 250
    if (media.gtSm) return windowHeight * 0.8
    return windowHeight - 50
  }, [media.gtLg, media.gtMd, media.gtSm, windowHeight])

  return (
    <Modal
      onClose={onClose}
      open={open}
      snapPointsMode="percent"
      snapPoints={snapPoints}
      shouldAdapt={false}
      maxWidth={modalMaxWidth}
      disableDrag
    >
      <YStack flex={1} justifyContent="flex-start">
        {media.sm && (
          <Button
            justifyContent="center"
            alignItems="center"
            position="absolute"
            top={10}
            right={5}
            h={32}
            w={32}
            unstyled
            backgroundColor="transparent"
            onPress={onClose}
          >
            <HeroIcon icon={['fas', 'xmark']} size={16} color="$icon-primary" />
          </Button>
        )}
        <YStack
          padding={media.gtSm ? '$size.spacing-lg' : '$size.spacing-xxs'}
          marginTop="$size.spacing-xl"
          flex={1}
        >
          <YStack flex={1}>
            <ScrollBar
              displayNativeIndicator={false}
              scrollBarId="course-description-modal"
              maxHeight={maxHeight}
            >
              <YStack paddingBottom={media.gtSm ? 0 : 100} h="100%">
                {description && (
                  <MediaRender
                    media={{
                      title: '',
                      type: 'Text',
                      text: description,
                      id: 1,
                      duration: null,
                      fileUrl: null,
                      fileExt: null,
                      hostKey: null,
                      host: null,
                      organizationUuid: null,
                      originUrl: null,
                    }}
                  />
                )}
              </YStack>
            </ScrollBar>
          </YStack>
        </YStack>
      </YStack>
    </Modal>
  )
}
